import documentService from '../../services/document.service';
import { AppDispatch } from '../../store';

// Action constants
export const documentConstants = {
  // Folder constants
  CREATE_FOLDER_REQUEST: 'DOCUMENT_CREATE_FOLDER_REQUEST',
  CREATE_FOLDER_SUCCESS: 'DOCUMENT_CREATE_FOLDER_SUCCESS',
  CREATE_FOLDER_FAILURE: 'DOCUMENT_CREATE_FOLDER_FAILURE',

  GET_FOLDER_CONTENTS_REQUEST: 'DOCUMENT_GET_FOLDER_CONTENTS_REQUEST',
  GET_FOLDER_CONTENTS_SUCCESS: 'DOCUMENT_GET_FOLDER_CONTENTS_SUCCESS',
  GET_FOLDER_CONTENTS_FAILURE: 'DOCUMENT_GET_FOLDER_CONTENTS_FAILURE',

  UPDATE_FOLDER_REQUEST: 'DOCUMENT_UPDATE_FOLDER_REQUEST',
  UPDATE_FOLDER_SUCCESS: 'DOCUMENT_UPDATE_FOLDER_SUCCESS',
  UPDATE_FOLDER_FAILURE: 'DOCUMENT_UPDATE_FOLDER_FAILURE',

  DELETE_FOLDER_REQUEST: 'DOCUMENT_DELETE_FOLDER_REQUEST',
  DELETE_FOLDER_SUCCESS: 'DOCUMENT_DELETE_FOLDER_SUCCESS',
  DELETE_FOLDER_FAILURE: 'DOCUMENT_DELETE_FOLDER_FAILURE',

  // File constants
  UPLOAD_FILE_REQUEST: 'DOCUMENT_UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS: 'DOCUMENT_UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'DOCUMENT_UPLOAD_FILE_FAILURE',

  UPDATE_FILE_REQUEST: 'DOCUMENT_UPDATE_FILE_REQUEST',
  UPDATE_FILE_SUCCESS: 'DOCUMENT_UPDATE_FILE_SUCCESS',
  UPDATE_FILE_FAILURE: 'DOCUMENT_UPDATE_FILE_FAILURE',

  DELETE_FILE_REQUEST: 'DOCUMENT_DELETE_FILE_REQUEST',
  DELETE_FILE_SUCCESS: 'DOCUMENT_DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'DOCUMENT_DELETE_FILE_FAILURE',

  DOWNLOAD_FILE_REQUEST: 'DOCUMENT_DOWNLOAD_FILE_REQUEST',
  DOWNLOAD_FILE_SUCCESS: 'DOCUMENT_DOWNLOAD_FILE_SUCCESS',
  DOWNLOAD_FILE_FAILURE: 'DOCUMENT_DOWNLOAD_FILE_FAILURE',

  // Search constants
  SEARCH_REQUEST: 'DOCUMENT_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'DOCUMENT_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'DOCUMENT_SEARCH_FAILURE',

  // Modification request constants
  CREATE_REQUEST_REQUEST: 'DOCUMENT_CREATE_REQUEST_REQUEST',
  CREATE_REQUEST_SUCCESS: 'DOCUMENT_CREATE_REQUEST_SUCCESS',
  CREATE_REQUEST_FAILURE: 'DOCUMENT_CREATE_REQUEST_FAILURE',

  GET_PENDING_REQUESTS_REQUEST: 'DOCUMENT_GET_PENDING_REQUESTS_REQUEST',
  GET_PENDING_REQUESTS_SUCCESS: 'DOCUMENT_GET_PENDING_REQUESTS_SUCCESS',
  GET_PENDING_REQUESTS_FAILURE: 'DOCUMENT_GET_PENDING_REQUESTS_FAILURE',

  REVIEW_REQUEST_REQUEST: 'DOCUMENT_REVIEW_REQUEST_REQUEST',
  REVIEW_REQUEST_SUCCESS: 'DOCUMENT_REVIEW_REQUEST_SUCCESS',
  REVIEW_REQUEST_FAILURE: 'DOCUMENT_REVIEW_REQUEST_FAILURE',
};

export const documentActions = {
  createFolder,
  getFolderContents,
  updateFolder,
  deleteFolder,
  uploadFile,
  updateFile,
  deleteFile,
  downloadFile,
  searchDocuments,
  createModificationRequest,
  getPendingRequests,
  reviewModificationRequest,
};

// Folder actions
function createFolder(data: { name: string; parentId?: number }) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.createFolder(data)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.CREATE_FOLDER_REQUEST };
  }
  function success(folder: any) {
    return { type: documentConstants.CREATE_FOLDER_SUCCESS, folder };
  }
  function failure(error: string) {
    return { type: documentConstants.CREATE_FOLDER_FAILURE, error };
  }
}

function getFolderContents(folderId: string | number) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.getFolderContents(folderId)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.GET_FOLDER_CONTENTS_REQUEST };
  }
  function success(data: any) {
    return { type: documentConstants.GET_FOLDER_CONTENTS_SUCCESS, data };
  }
  function failure(error: string) {
    return { type: documentConstants.GET_FOLDER_CONTENTS_FAILURE, error };
  }
}

function updateFolder(id: number, data: { name: string }) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.updateFolder(id, data)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.UPDATE_FOLDER_REQUEST };
  }
  function success(folder: any) {
    return { type: documentConstants.UPDATE_FOLDER_SUCCESS, folder };
  }
  function failure(error: string) {
    return { type: documentConstants.UPDATE_FOLDER_FAILURE, error };
  }
}

function deleteFolder(id: number) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.deleteFolder(id)
      .then(
        (response) => dispatch(success(id)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.DELETE_FOLDER_REQUEST };
  }
  function success(id: number) {
    return { type: documentConstants.DELETE_FOLDER_SUCCESS, id };
  }
  function failure(error: string) {
    return { type: documentConstants.DELETE_FOLDER_FAILURE, error };
  }
}

// File actions
function uploadFile(formData: FormData, onUploadProgress?: (progressEvent: any) => void) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.uploadFile(formData, onUploadProgress)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.UPLOAD_FILE_REQUEST };
  }
  function success(file: any) {
    return { type: documentConstants.UPLOAD_FILE_SUCCESS, file };
  }
  function failure(error: string) {
    return { type: documentConstants.UPLOAD_FILE_FAILURE, error };
  }
}

function updateFile(id: number, data: { name: string }) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.updateFile(id, data)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.UPDATE_FILE_REQUEST };
  }
  function success(file: any) {
    return { type: documentConstants.UPDATE_FILE_SUCCESS, file };
  }
  function failure(error: string) {
    return { type: documentConstants.UPDATE_FILE_FAILURE, error };
  }
}

function deleteFile(id: number) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.deleteFile(id)
      .then(
        (response) => dispatch(success(id)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.DELETE_FILE_REQUEST };
  }
  function success(id: number) {
    return { type: documentConstants.DELETE_FILE_SUCCESS, id };
  }
  function failure(error: string) {
    return { type: documentConstants.DELETE_FILE_FAILURE, error };
  }
}

function downloadFile(id: number) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.downloadFile(id)
      .then(
        (blob) => dispatch(success(blob)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.DOWNLOAD_FILE_REQUEST };
  }
  function success(blob: any) {
    return { type: documentConstants.DOWNLOAD_FILE_SUCCESS, blob };
  }
  function failure(error: string) {
    return { type: documentConstants.DOWNLOAD_FILE_FAILURE, error };
  }
}

// Search action
function searchDocuments(query: string) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.searchDocuments(query)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.SEARCH_REQUEST };
  }
  function success(results: any) {
    return { type: documentConstants.SEARCH_SUCCESS, results };
  }
  function failure(error: string) {
    return { type: documentConstants.SEARCH_FAILURE, error };
  }
}

// Modification request actions
function createModificationRequest(data: {
  requestType: 'delete' | 'edit';
  targetType: 'file' | 'folder';
  targetId: number;
  reason: string;
  newData?: any;
}) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.createModificationRequest(data)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.CREATE_REQUEST_REQUEST };
  }
  function success(modRequest: any) {
    return { type: documentConstants.CREATE_REQUEST_SUCCESS, modRequest };
  }
  function failure(error: string) {
    return { type: documentConstants.CREATE_REQUEST_FAILURE, error };
  }
}

function getPendingRequests() {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.getPendingRequests()
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.GET_PENDING_REQUESTS_REQUEST };
  }
  function success(requests: any) {
    return { type: documentConstants.GET_PENDING_REQUESTS_SUCCESS, requests };
  }
  function failure(error: string) {
    return { type: documentConstants.GET_PENDING_REQUESTS_FAILURE, error };
  }
}

function reviewModificationRequest(
  id: number,
  data: { status: 'approved' | 'rejected'; reviewNote?: string }
) {
  return (dispatch: AppDispatch) => {
    dispatch(request());

    documentService.reviewModificationRequest(id, data)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: documentConstants.REVIEW_REQUEST_REQUEST };
  }
  function success(modRequest: any) {
    return { type: documentConstants.REVIEW_REQUEST_SUCCESS, modRequest };
  }
  function failure(error: string) {
    return { type: documentConstants.REVIEW_REQUEST_FAILURE, error };
  }
}
